
import Loading from 'vux/src/components/loading/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Icon from 'vux/src/components/icon/index.vue'


export default {
components: {
Loading,
XHeader,
XButton,
Group,
Checker,
CheckerItem,
XTextarea,
Icon
},
data () {
return {
loading: true,
type: 0,
invenstemType: '',
data: {
isProfessionalInvestors: {
checked: ''
},
orgAssetsScale: {
checked: ''
},
isControllingShareholder: {
checked: '',
description: ''
},
transactionActualBeneficiary: {
checked: '',
description: ''
},
isBadFaith: {
checked: '',
description: ''
}
}
}
},
watch: {
'data.orgAssetsScale.checked': function (val, oldVal) {
this.$_personal_toast(val, oldVal)
}
},
created () {
this.$vux.loading.show({text: '加载中'})
this.$bridge.registerHandler('getUpdate', this.$_agency_update)
this.$_agency_init()
},
mounted () {
let _this = this
_this.$bridge.callHandler('getUserInfo', {message: '获取投资者类型'}, (res) => {
let data = JSON.parse(res)
if (data.invenstemType) {
_this.invenstemType = data.invenstemType
}
})
},
methods: {
$_agency_update () {
this.type = 1
},
$_agency_init () {
let _this = this
setTimeout(() => {
_this.data.isProfessionalInvestors.checked = parseInt(this.$route.query.isNormal) === 1 ? '否' : '是'
_this.type = parseInt(this.$route.query.type)
if (_this.$route.query.oldInfo) {
let res = JSON.parse(this.$route.query.oldInfo)
_this.data = {
isProfessionalInvestors: {
checked: JSON.parse(res.isProfessionalInvestors).checked
},
orgAssetsScale: {
checked: JSON.parse(res.orgAssetsScale).checked
},
isControllingShareholder: {
checked: JSON.parse(res.isControllingShareholder).checked,
description: JSON.parse(res.isControllingShareholder).description
},
transactionActualBeneficiary: {
checked: JSON.parse(res.transactionActualBeneficiary).checked,
description: JSON.parse(res.transactionActualBeneficiary).description
},
isBadFaith: {
checked: JSON.parse(res.isBadFaith).checked,
description: JSON.parse(res.isBadFaith).description
}
}
}
_this.loading = false
_this.$vux.loading.hide()
}, 500)
},
$_agency_submit () {
for (let item in this.data) {
if (this.data[item].checked === '') {
this.$vux.toast.show({
type: 'warn',
text: '选择为空或输入不合规范'
})
return
}
let isControllingShareholder = item === 'isControllingShareholder' && this.data[item].checked === '是' && this.data[item].description === ''
let transactionActualBeneficiary = item === 'transactionActualBeneficiary' && this.data[item].checked === '其他机构或个人' && this.data[item].description === ''
let isBadFaith = item === 'isBadFaith' && this.data[item].checked === '是' && this.data[item].description === ''
if (isControllingShareholder || transactionActualBeneficiary || isBadFaith) {
this.$vux.toast.show({
type: 'warn',
text: '请输入说明内容'
})
return
}
}
this.$_agency_commit(Object.assign({}, this.data, this.$route.query))
},
$_agency_commit (json) {
delete json.oldInfo
delete json.type
delete json.isNormal
if (this.isDev) {
console.log(JSON.stringify(json))
} else {
this.$bridge.callHandler('getResult', {message: '最后确认', json: JSON.stringify(json)}, function (data) {
console.log('submit')
})
}
},
$_personal_toast (val, oldVal) {
let _this = this
if (this.type === 1) {

if (_this.invenstemType === 'SPECIFIC_ORG_PRACTITIONERS') {
if (val === '否') {
_this.$vux.alert.show({
title: '提示',
content: '据《私募投资基金募集行为管理办法》32条规定，此项选“否”，将标记该投资者为“投资于所管理私募基金的私募基金管理人”，即当然合格投资者，后续无需签署合格投资者承诺函'
})
}
}

if (_this.invenstemType === 'SPECIFIC_ORG_PROFESSION' || _this.invenstemType === 'SPECIFIC_ORG_ORDINARY') {
if (val === '否') {
_this.$vux.alert.show({
title: '提示',
content: '根据《证券期货投资者适当性管理办法》第十四条“一定时期”的规定，私募基金合格投资者必须满足该条件，若您确认选否，该投资者则不符合私募基金购买条件，我们将终止本投资者信息表的填写',
onHide () {
_this.data.orgAssetsScale.checked = oldVal
}
})
}
}

if (_this.invenstemType === 'SPECIFIC_ORG_ORG') {

if (val === '否') {
this.$vux.alert.show({
title: '提示',
content: '据《私募投资基金监督管理暂行办法》13条、《私募投资基金募集行为管理办法》32条规定，此项选“否”，将标记该投资者为“产品类投资者”，即当然合格投资者，后续无需签署合格投资者承诺函。且仅能用该机构管理的产品作为投资主体进行签约。'
})
} else {
this.$vux.alert.show({
title: '提示',
content: '此项选“是”，将标记该投资者为“金融机构投资者”。后续可用该机构及机构管理的产品作为投资主体进行签约。'
})
}
}
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/InvestorInfo/Agency/Question.vue